import * as React from 'react';

import Progress from '../ProgessBar/ProgessBar';
import ButtonArrow from '../FerrariIcon/ButtonArrow';

import cl from 'classnames';

import s from './CompletePage.module.css';
import {logout} from '@actions/login';
import {useDispatch} from 'react-redux';

export default function CompletedPage(props) {
  const dispatch = useDispatch();
  const {testsCompleted, testsTotal, sections, order, percent, current, outro} = props;
  return (
    <div>
      <div className={cl(s.Description)}>
        <div className={s.Welcome}> Congrats </div>
        <div className={s.WelcomeText}>{outro}</div>
      </div>
      <div className={cl(s.Progressbar)}>
        <Progress
          testsCompleted={testsCompleted}
          testsTotal={testsTotal}
          sections={sections}
          percent={percent}
          current={current}
          order={order}
        />
      </div>
      <div className={s.StartButtonWrapper}>
        <button className={cl(s.StartButton)} onClick={() => dispatch(logout())}>
          Exit
          <ButtonArrow />
        </button>
      </div>
    </div>
  );
}
